import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    details: null,
    school: null,
    teachers: [],
    settings: null,
}

export const schoolAdminAccountSlice = createSlice({
    name: 'schoolAdmin',
    initialState,
    reducers: {
        updateSchoolAdminAccount: (state, action) => {
            console.log('saving school admin account to redux');
            state.details = action.payload?.details ? action.payload?.details : state.details;
            state.school = action.payload?.school ? action.payload?.school : state.school;
            state.teachers = action.payload?.teachers ? action.payload?.teachers : state.teachers;
            state.settings = action.payload?.settings ? action.payload?.settings : state.settings;
            console.log('Updated school account state:', {
                details: state.details,
                school: state.school,
                teachers: state.teachers,
                settings: state.settings
            });
        },
        updateSchoolAdminDetails: (state, action) => {
            console.log('saving school details to redux');
            state.details = action.payload;
        },
        updateSchoolAdminTeachers: (state, action) => {
            console.log('saving school teachers to redux');
            state.teachers = action.payload;
        },
        updateSchoolAdminSettings: (state, action) => {
            console.log('saving school settings to redux');
            state.settings = action.payload;
        },

        updateSchoolAdminSchool: (state, action) => {
            console.log('saving school details to redux');
            state.school = action.payload;
        },

        updateSchoolPaymentSettings(state, action) {
            state.school.payment_setting = action.payload;
        },
        clearSchoolAdminAccount: (state) => {
            console.log('clearing school admin account from redux');
            state.details = null;
            state.school = null;
            state.teachers = [];
            state.settings = null;
        },

    }
});

export const {
    updateSchoolAdminAccount,
    updateSchoolAdminDetails,
    updateSchoolAdminTeachers,
    updateSchoolAdminSettings,
    updateSchoolAdminSchool,
    updateSchoolPaymentSettings,
    clearSchoolAdminAccount,
} = schoolAdminAccountSlice.actions;

export default schoolAdminAccountSlice.reducer;
